module.exports = __webpack_public_path__ + "img/4.90bc60eb.jpg";